import { render } from "./Pidging.vue?vue&type=template&id=6d0c31fb&scoped=true"
import script from "./Pidging.vue?vue&type=script&lang=js"
export * from "./Pidging.vue?vue&type=script&lang=js"

import "./Pidging.vue?vue&type=style&index=0&id=6d0c31fb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d0c31fb"]])

export default __exports__